<template>
  <div :class="`${question.answerColClass || 'col'} field`">
    <input
      :name="question.labelInput"
      :placeholder="question.placeholder"
      :disabled="question.disabled && isDisabled"
      min="0"
      :class="['form-control', filled, question.fieldClass]"
      :value="response"
      @change="e => setValue({ path, responsePath, value: e.target.value })"
      @input="e => checkError({ path, responsePath, value: e.target.value })"
    />

    <label v-if="question.labelInput">
      {{ question.labelInput }}
      <tooltip-element
        v-if="question.tooltipImage || question.tooltipText"
        :class="['question-tooltip']"
        :question="question"
      />
    </label>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";

import { getProp } from "../../utils/SurveyUtils";

export default {
  props: ["question", "path", "responsePath"],
  computed: {
    ...mapGetters(["isDisabled"]),
    response() {
      return getProp(this.question, this.responsePath, "response");
    },
    filled() {
      return this.response && this.response.length > 0 && "filled";
    },
  },
  methods: {
    ...mapActions(["setValue", "checkError"]),
  },
};
</script>
